import { apiFetch } from './client';
import type {
  AgentRun,
  AgentRunDetail,
  Paginated,
} from './types';

export interface ListAgentRunsParams {
  page?: number;
  pageSize?: number;
  workflowId?: string;
  projectId?: string;
  from?: string;
  to?: string;
}

export const listAgentRuns = (params: ListAgentRunsParams = {}) => {
  const qs = new URLSearchParams();
  if (params.page) qs.set('page', String(params.page));
  if (params.pageSize) qs.set('pageSize', String(params.pageSize));
  if (params.workflowId) qs.set('workflowId', params.workflowId);
  if (params.projectId) qs.set('projectId', params.projectId);
  if (params.from) qs.set('from', params.from);
  if (params.to) qs.set('to', params.to);
  const q = qs.toString();
  return apiFetch<Paginated<AgentRun>>(
    `/agent-runs${q ? `?${q}` : ''}`,
  );
};

export const getAgentRunDetail = (id: string) =>
  apiFetch<AgentRunDetail>(`/agent-runs/${id}`);
